import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import ActorHairStyle from '../../../domain/entities/ActorHairStyle';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexActorHairStylesSuccess: {
      const result = action.payload as PaginatedResult<ActorHairStyle>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
